<template>
    <div :class='{"header-menu__sub-menu": true, "header-menu__sub-menu--wide": isWide, "header-menu__sub-menu--wider": isWider}'>
        <div class="header-menu__sub-menu-inner header-menu__sub-menu-inner--cols">
            <template v-for="(column, columnName) in content">
                <template v-if="column.length > 10">
                    <ul class="header-menu__sub-menu-col header-menu__sub-menu-col--models" :key="columnName">
                        <li class="header-menu__sub-menu-col-li" v-for="(item, index) in column" :key="index" :class="{'header-menu--sub-title': item.h, 'header-menu__sub-menu-col-li--models': item.h}">
                            <a v-if="item.h && item.l" :href="item.l" class="header-menu__sub-menu-col-a header-menu--sub-title">{{ item.t }}</a>
                            <template v-else-if="item.h && !item.l">{{ item.t }}</template>
                            <a v-else :href="item.l" class="header-menu__sub-menu-col-a">{{ item.t }}</a>
                        </li>
                    </ul>
                </template>
                <template v-else>
                    <ul class="header-menu__sub-menu-col" :key="columnName">
                        <li class="header-menu__sub-menu-col-li" v-for="(item, index) in column" :key="index" :class="{'header-menu--sub-title': item.h}">
                            <a v-if="item.h && item.l" :href="item.l" class="header-menu__sub-menu-col-a header-menu--sub-title">{{ item.t }}</a>
                            <template v-else-if="item.h && !item.l">{{ item.t }}</template>
                            <a v-else :href="item.l" class="header-menu__sub-menu-col-a">{{ item.t }}</a>
                        </li>
                    </ul>
                </template>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        content: {
            required: true
        },
        isWide: {
            type: Boolean,
            default: false,
            required: false
        },
        isWider: {
            type: Boolean,
            default: false,
            required: false
        },
    },
    computed: {

    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// resources/assets/js/used-vue/components/Layout/Menus/DesktopSubMenuContent.vue